export const useDynamicPageStore = defineStore('dynamicPage', {
  state: () => ({
    pageType: null,
  }),
  actions: {
    setPageType(type) {
      this.pageType = type;
    },
  },
  getters: {
    isRolePage: (state) => state.pageType === 'role',
    isLeadGenPage: (state) => state.pageType === 'leadgen',
  },
});
